<template lang="pug"></template>
<script>
    export default {
        name: 'tab-blur-watcher',
        props: {},
        data() {
            return {}
        },
        created() {
            this.$nextTick(() => this.init());
        },
        methods: {
            init() {
                window.onfocus = () => this.focus();
                window.onblur  = () => this.blur();
            },
            focus() {
                let blurTime  = localStorage.getItem('blur-time'),
                    focusTime = new Date().getTime(),
                    expTime   = 0;
                if (!blurTime) return;
                expTime = (focusTime - blurTime)/1000; //Прошло времени в секундах с момента блюра
                if (expTime > (60 * 15)) this.$router.go(); //Если прошло больше 15 минут, обновляем все компоненты
            },
            blur() {
                localStorage.setItem('blur-time', new Date().getTime());
            }
        }
    }
</script>
<style scoped lang="sass">
</style>


// WEBPACK FOOTER //
// TabBlurWatcher.vue?5c42d4d5